import { findContentElements } from './findAllContentElements';

export function findAllFocusableElements(element: ChildNode): HTMLElement[] {
  return findContentElements(element, {});
}
